import { PROFILE_ENVIRONMENT, PROFILE_ID } from "./enums";

export default {
  chatbotId: PROFILE_ID.SKY_CORPORATE_CL_CHATBOT_ES,
  credentials: [
    {
      environment: PROFILE_ENVIRONMENT.DEVELOPMENT,
      inbentaKey: "BeMVg+CpsbDLBQTtGp25UOa+8I6BJ0OGXfDHXSikEs0=",
      domainKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0Ijoic2t5X2NvcnBvcmF0ZV9jbF9jaGF0Ym90X2VzIiwiZG9tYWluX2tleV9pZCI6IkJoVTBqTnZOR0RtVE96N1gtSEFqZWc6OiJ9.GbOgbAvIIvImeH6aqDbmOEsR7ppsDuivfmhtoIyIdKK1nTFrcMPRKORm6tNRhV8iA4d0aF6CEGwIFp3JHqhhiQ",
    },
    {
      environment: PROFILE_ENVIRONMENT.PRODUCTION,
      inbentaKey: "BeMVg+COyK3QhlucqVckQE6XszWcrJHS3lPMskMHU7o=",
      domainKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0Ijoic2t5X2NvcnBvcmF0ZV9jbF9jaGF0Ym90X2VzIiwiZG9tYWluX2tleV9pZCI6IkJoaHFGZWxnLXROSk9lMjBUZVBoUXc6OiJ9.AWA4X1h_qRqVGxpFobEs3Jz47961myK4GgMfkOON-LctVmConuBQXSoxThDfx3ftzPE1RxM7bOX8JvwHMLlCVQ",
    },
  ],
};
